import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiLayers, FiMail } from 'react-icons/fi';
import { CATEGORIES, byCategory } from '../data/catalog';
import { COMPANY, disclosure } from '../data/company';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background border-t border-border py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 pb-10 mb-10 border-b border-border">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <SafeIcon icon={FiLayers} className="w-6 h-6 text-accent-red" />
              <span className="font-semibold text-white">MediaVerse Labs</span>
            </Link>
            <p className="text-muted text-sm max-w-xs">
              Building premium, ad-free, privacy-first games, software and browser extensions.
            </p>
          </div>
          <a href="mailto:hello@mediaverselabs.com" className="flex items-center gap-2 text-sm text-muted hover:text-accent-red transition-colors">
            <SafeIcon icon={FiMail} /> hello@mediaverselabs.com
          </a>
        </div>

        {/* One column per catalog category, driven from the catalog so a new release or a
            new category never has to be remembered here. Empty categories are skipped. */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-x-8 gap-y-10">
          {CATEGORIES.map((cat) => ({ cat, items: byCategory(cat.id) }))
            .filter(({ items }) => items.length > 0)
            .map(({ cat, items }) => (
              <div key={cat.id}>
                <h3 className="text-white font-medium mb-4">
                  <Link to={`/products#${cat.id}`} className="hover:text-accent-red transition-colors">{cat.name}</Link>
                </h3>
                <ul className="space-y-3 text-sm">
                  {items.map((product) => (
                    <li key={product.id}>
                      {/* Products without an internal page (link: null) live on their own site. */}
                      {product.link ? (
                        <Link to={product.link} className="text-muted hover:text-white transition-colors">
                          {product.name}
                        </Link>
                      ) : (
                        <a href={product.siteLink} target="_blank" rel="noopener noreferrer" className="text-muted hover:text-white transition-colors">
                          {product.name}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}

          <div>
            <h3 className="text-white font-medium mb-4">Legal &amp; Support</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/privacy" className="text-muted hover:text-white transition-colors">Privacy</Link></li>
              <li><Link to="/terms" className="text-muted hover:text-white transition-colors">Terms</Link></li>
              <li><Link to="/disclaimer" className="text-muted hover:text-white transition-colors">Disclaimer</Link></li>
              <li><Link to="/support" className="text-muted hover:text-white transition-colors">Support</Link></li>
            </ul>
          </div>
        </div>

        {/* Statutory trading disclosure. Required on the website of a UK company
            trading under a name other than its registered one, so it belongs in the
            footer of every page rather than only on the legal pages. */}
        <div className="mt-12 pt-8 border-t border-border space-y-4">
          <p className="text-muted text-xs leading-relaxed max-w-3xl">{disclosure}</p>
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <p className="text-muted text-xs">
              &copy; {currentYear} {COMPANY.legalName}. All rights reserved.
            </p>
            <span className="text-xs text-muted">
              Windows and Microsoft Store are trademarks of Microsoft Corporation.
              Chrome and the Chrome Web Store are trademarks of Google LLC.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
